import { useSelector } from "react-redux";
import { getCookie } from "../cookie/cookie";
import { useEffect, useState } from "react";
import { selectIsUserFromShopify, selectLogInUsername } from "../../common/authenticateDashboard/authSlice";

function useAuth() {
    const sessionUser = useSelector(selectLogInUsername);
    const isReferrerShopify = useSelector(selectIsUserFromShopify)

    // console.log("sessionUser in useAuth", sessionUser);
    // console.log("userId in useAuth", getCookie('user'));

    const [user, setUser] = useState(null); 
    useEffect(() => {
        if (isReferrerShopify) {
            setUser(sessionUser);
        } else {
            let userId = getCookie('user');
            // if(userId?.includes("_prod@causalfunnel.com")){
            //     userId = userId.split("_prod@causalfunnel.com")[0] + "-prod@causalfunnel.com";
            // }
            console.log("userId in else condition", userId);
            setUser(userId);
        }
    }, [isReferrerShopify, sessionUser]);

    return user;
}

export default useAuth;